import React, {Component} from 'react';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';

class ModalContentVideoPlayer extends Component {

    render() {

        return (
            <div className="video-player">
                <ReactPlayer controls={true} width='100%' url={this.props.url} playing />
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(ModalContentVideoPlayer);





// WEBPACK FOOTER //
// ./src/SHARED/components/modalcontentvideoplayer/modalcontentvideoplayer.component.js